import { OpenNewTabTargetType } from "@voltmoney/types";
import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
import sharedPropsService from "../../SharedPropsService";
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { isFromAndroidWebview } from "../../configs/utils";
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
export const promoBannerInvite = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("COLLATERAL_REQUEST_INITIATED", {
        "page": "collateral"
    });
    console.warn('**** promoBannerInvite Action Triggered ****', action);
    openNewTab(`https://wa.me/919611749295?text=Kindly%20provide%20me%20with%20personalized%20co-branded%20marketing%20materials%20to%20help%20educate%20my%20clients.`, OpenNewTabTargetType.blank);
};
export const onDownLoadEarningReport = async (action, _datastore, { network, asyncStorage, setDatastore }) => {
    const earningReportMonth = await sharedPropsService.getFirebaseConfig()?.earnings_report_month;
    await setDatastore(ROUTE.EARNING, "downLoadButton", {
        loading: true
    });
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountID = _user?.linkedPartnerAccounts[0]?.accountId;
    const partnerName = _user?.linkedPartnerAccounts[0]?.partnerName.replace(/ /g, "_");
    const response = await network.get(`${partnerApi.getDownloadURL}${partnerAccountID}/month/${earningReportMonth.toLowerCase()}/year/2024`, {
        headers: await getAppHeader(),
    }, async () => {
        return;
    }, {
        isPartnerPlatform: true
    });
    const downloadURL = response.data.url;
    const extension = response.data.fileExtension;
    fetch(downloadURL)
        .then((response) => response.blob())
        .then((blob) => {
        // Create a temporary anchor element to initiate the download
        if (isFromAndroidWebview()) {
            window.open(`${downloadURL}/?partnerDetails&partnerName=` + encodeURIComponent(partnerName) + "&earningReportMonth=" + encodeURIComponent(earningReportMonth) + "&extension=" + encodeURIComponent(extension));
            setTimeout(() => {
                setDatastore(ROUTE.EARNING, "downLoadButton", {
                    loading: false
                });
            }, 3000);
        }
        else {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const a = document.createElement('a');
            a.href = url;
            a.download = `${partnerName}_earnings_report_${earningReportMonth.toLowerCase()}_2024.${extension}`;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDatastore(ROUTE.EARNING, "downLoadButton", {
                loading: false
            });
        }
    })
        .catch((error) => {
        console.warn('Error download file: ', error);
    });
};
